import { FormVmItemConfigType } from '../../../../../infrastructure/form-viewmodel-controller';
import { buildConfigList } from '../../../../../infrastructure/utils/form-config.utils';
import { trimSpacesLeft } from '../../../../../modules/formatters';
import { plainText } from '../../../../../modules/validators';

export enum EventAttributeFieldKey {
    NAME = 'name',
    DESCRIPTION = 'description',
    INPUT_TYPE = 'inputType',
    IS_ACTIVE = 'isActive',
    EXTERNAL_ID = 'externalId'
 }

export const FORM_CONFIG = {
    [EventAttributeFieldKey.NAME]: {
        labelDescriptor: { id: 'oe.eventAttributes.name', defaultMessage: 'Name', description: 'Label text' },
        defaultValue: '',
        validators: [ plainText.required, plainText.maxLength.short ],
        formatters: [ trimSpacesLeft ]
    },
    [EventAttributeFieldKey.DESCRIPTION]: {
        labelDescriptor: { id: 'oe.eventAttributes.description', defaultMessage: 'Description', description: 'Label text' },
        defaultValue: '',
        validators: [ plainText.maxLength.medium],
        formatters: [trimSpacesLeft]
    },
    [EventAttributeFieldKey.EXTERNAL_ID]: {
        labelDescriptor: { id: 'oe.eventAttributes.externalId', defaultMessage: 'External ID', description: 'Label text' },
        defaultValue: '',
        validators: [ plainText.maxLength.short],
        formatters: [trimSpacesLeft]
    },
    [EventAttributeFieldKey.INPUT_TYPE]: {
        labelDescriptor: { id: 'oe.eventAttributes.inputType', defaultMessage: 'Input Type', description: 'Label text' },
        defaultValue: '',
        validators: [plainText.required]
    },
    [EventAttributeFieldKey.IS_ACTIVE]: {
        defaultValue: true
    },
};


export const configList: FormVmItemConfigType[] = buildConfigList(FORM_CONFIG);
